import { render, staticRenderFns } from "./ArtworkEditModal.vue?vue&type=template&id=150150bf&scoped=true"
import script from "./ArtworkEditModal.vue?vue&type=script&lang=js"
export * from "./ArtworkEditModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkEditModal.vue?vue&type=style&index=0&id=150150bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150150bf",
  null
  
)

export default component.exports